
import axios from '../../helpers/axios';


export const updatedPaymentAccount = (id, updatePaymentAccount) => axios.patch(`/paymentAccount/update/${id}`, updatePaymentAccount)
export const deletedPaymentAccount = (id) => axios.delete(`/paymentAccount/delete/${id}`)
